var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRodin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1800 1117",
    style: {
      enableBackground: "new 0 0 1800 1117"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000095333795098565831050000011615836798309477291_);}\n\t.st1{fill:#5A6673;}\n\t.st2{fill:#424A54;}\n\t.st3{fill:#30363D;}\n\t.st4{fill:#161B22;}\n\t.st5{fill:#DD8033;}\n\t.st6{fill:#DD3333;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 1800,
    height: 1116.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172408280048594898550000018269185330165173930_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000172408280048594898550000018269185330165173930_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M778.8,1098.5h-361l166.9-54.8h361L778.8,1098.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M778.9,1098.5H417.8v17.9h361.1V1098.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M945.7,1061.6l-166.9,54.7v-17.8l166.9-54.8V1061.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.8,626h-51.2l31.6-13h51.1L281.8,626z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.7,626h-51.1v57.7h51.1V626z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313.4,670.7l-31.5,13V626l31.5-13V670.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1464.1,97H1413l31.6-13h51.1L1464.1,97z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1464.1,97H1413v57.7h51.1V97z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1495.8,141.7l-31.6,13V97l31.6-13V141.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1264.4,1115.6H882.7l74.6-22.7h301.7l444.2-221.1H540.9L96.7,1092.8h289.1l-57,22.7H0L535.6,849H1800 L1264.4,1115.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.3,852.6h-82.1l83.2-27.2h82.1L430.3,852.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.3,852.6h-82.1v152.1h82.1V852.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M513.5,977.4l-83.2,27.3V852.6l83.2-27.2V977.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1089.7,26.6H474.4L543.9,0h615.4L1089.7,26.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1089.8,26.6H474.4v978.1h615.4V26.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1159.3,978.1l-69.6,26.6V26.6L1159.3,0V978.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M765.5,318.5h-252v640.2h252V318.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1043.8,318.5h-252v640.2h252V318.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M808.9,867.2l217.8-124.4v-38L808.9,829.1V867.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M917.8,831.1v38.1l-108.9,62.2v-38.1L917.8,831.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M530.6,664.8l217.8-124.4v-38L530.6,626.7V664.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M639.4,628.8v38.1l-108.9,62.2V691L639.4,628.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M450,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.5C476.5,467.9,464.6,479.8,450,479.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M476.5,453.4l-53.6,17.5v-98.5l53.6-17.5V453.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M404.6,496l54.8-18l17.1-24.7l-53.6,17.5L404.6,496z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.4,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.4C422.9,485.6,411.1,497.4,396.4,497.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.9,372.4H370l53.6-17.5h52.9L422.9,372.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M515.8,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.5C542.3,467.9,530.4,479.8,515.8,479.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M542.3,453.4l-53.6,17.5v-98.5l53.6-17.5V453.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M470.5,496l54.7-18l17.1-24.7l-53.6,17.5L470.5,496z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M462.2,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.4C488.7,485.6,476.9,497.4,462.2,497.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M488.7,372.4h-52.9l53.6-17.5h52.9L488.7,372.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M581.5,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5H608v98.5C608,467.9,596.2,479.8,581.5,479.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M608,453.4l-53.6,17.5v-98.5l53.6-17.5V453.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M536.2,496l54.7-18l17.1-24.7l-53.6,17.5L536.2,496z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M527.9,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.4C554.5,485.6,542.6,497.4,527.9,497.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M554.5,372.4h-52.9l53.6-17.5H608L554.5,372.4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M647.3,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.5C673.8,467.9,662,479.8,647.3,479.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M673.8,453.4l-53.6,17.5v-98.5l53.6-17.5V453.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M602,496l54.7-18l17.1-24.7l-53.6,17.5L602,496z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M593.8,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.4C620.2,485.6,608.4,497.4,593.8,497.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M620.2,372.4h-52.9l53.6-17.5h52.9L620.2,372.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M713.2,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.8v98.5C739.6,467.9,727.7,479.8,713.2,479.8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M739.6,453.4L686,470.9v-98.5l53.6-17.5V453.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M667.8,496l54.7-18l17.1-24.7L686,470.9L667.8,496z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.6,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.4C686,485.6,674.1,497.4,659.6,497.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M686,372.4h-52.9l53.6-17.5h52.9L686,372.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M778.9,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.5C805.3,467.9,793.5,479.8,778.9,479.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M805.3,453.4l-53.6,17.5v-98.5l53.6-17.5V453.4z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M733.5,496l54.7-18l17.1-24.7l-53.6,17.5L733.5,496z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M725.3,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.4C751.7,485.6,739.9,497.4,725.3,497.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M751.7,372.4h-52.9l53.6-17.5h52.9L751.7,372.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M844,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.8v98.5C870.4,467.9,858.6,479.8,844,479.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M870.4,453.4l-53.5,17.5v-98.5l53.5-17.5V453.4z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M798.6,496l54.8-18l17-24.7l-53.5,17.5L798.6,496z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M790.4,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.4C816.9,485.6,805,497.4,790.4,497.4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M816.9,372.4H764l53.6-17.5h52.8L816.9,372.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M909.1,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.5C935.6,467.9,923.8,479.8,909.1,479.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M935.6,453.4L882,470.9v-98.5l53.6-17.5V453.4z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M863.8,496l54.7-18l17.1-24.7L882,470.9L863.8,496z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M855.5,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5H882v98.4C882,485.6,870.2,497.4,855.5,497.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M882,372.4h-52.9l53.6-17.5h52.9L882,372.4z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M974.3,479.8c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.5C1000.7,467.9,988.9,479.8,974.3,479.8z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1000.7,453.4l-53.6,17.5v-98.5l53.6-17.5V453.4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M928.9,496l54.7-18l17.1-24.7l-53.6,17.5L928.9,496z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M920.7,497.4c-14.6,0-26.4-11.8-26.4-26.4v-98.5h52.9v98.4C947.1,485.6,935.3,497.4,920.7,497.4z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M947.1,372.4h-52.9l53.6-17.5h52.9L947.1,372.4z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1031.6,56.1H411.2L455,39.6h622L1031.6,56.1z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M976.6,384h-622l56.7-327.9h620.4L976.6,384z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1077,351.1L976.6,384l55.1-327.9l45.4-16.5V351.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1441,780.5l-37.2,206.1c0,5-20.2,9.2-48,10.6l11.9-216.7H1441z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1367.6,780.5l-12,216.7c-6.3,0.3-12.9,0.5-19.8,0.5c-37.4,0-67.8-5-67.8-11.1l-37.2-206.1h136.8V780.5z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1336,797.7c58,0,105-7.7,105-17.2c0-9.5-47-17.2-105-17.2c-58,0-105,7.7-105,17.2 C1231,790,1278,797.7,1336,797.7z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1336,791.9c49.8,0,90.1-5.1,90.1-11.4c0-6.3-40.3-11.4-90.1-11.4c-49.8,0-90.1,5.1-90.1,11.4 C1245.9,786.8,1286.2,791.9,1336,791.9z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1276.9,861.7l-25.9,143.5c0,3.5-14.1,6.5-33.4,7.4l8.3-150.9H1276.9L1276.9,861.7z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1225.9,861.7l-8.3,150.9c-4.3,0.2-9,0.3-13.8,0.3c-26.1,0-47.2-3.4-47.2-7.7l-25.9-143.5H1225.9 L1225.9,861.7z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1203.8,873.6c40.4,0,73.2-5.3,73.2-11.9s-32.8-11.9-73.2-11.9c-40.4,0-73.2,5.3-73.2,11.9 S1163.4,873.6,1203.8,873.6z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1203.8,869.7c34.7,0,62.8-3.6,62.8-8s-28.1-8-62.8-8c-34.7,0-62.8,3.6-62.8,8S1169.1,869.7,1203.8,869.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1347.8,783.9c-3.2,0-5.7-2.5-5.7-5.7V425.2c0-13.4,10.6-24.2,23.5-24.2c13,0,23.6,10.9,23.6,24.2v14.2 c0,3.2-2.5,5.7-5.7,5.7c-3.2,0-5.7-2.5-5.7-5.7v-14.2c0-7.1-5.5-12.9-12.2-12.9c-6.7,0-12.2,5.8-12.2,12.9v353.1 C1353.5,781.4,1350.9,783.9,1347.8,783.9z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1398.4,783.9c-0.6,0-1-0.1-1.6-0.2c-3.1-0.9-4.8-4.1-3.9-7.1l82-280.9c1.6-5.7,5.3-10.2,10.5-13 c4.9-2.6,10.6-3.2,15.8-1.5c11,3.4,17.3,15.5,13.9,26.8l-3.4,11.7c-0.9,3-4,4.8-7.1,3.9s-4.8-4.1-3.9-7.1l3.4-11.7 c1.6-5.5-1.2-11.1-6.5-12.9c-2.4-0.7-4.9-0.5-7.1,0.7c-2.4,1.3-4.1,3.4-4.9,6.1l-82,280.9C1403.1,782.3,1400.9,783.9,1398.4,783.9 z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1270.2,783.9c-2.7,0-5.1-1.9-5.6-4.8l-35.3-208.8c-0.2-1.6-1.1-3-2.4-3.9c-1.2-0.9-2.8-1.3-4.4-1 c-3.2,0.6-5.5,3.6-4.9,6.8l1.5,8.8c0.6,3.1-1.6,6-4.7,6.6c-3.1,0.6-6-1.6-6.6-4.7l-1.5-8.8c-1.6-9.4,4.8-18.4,14.2-20 c4.6-0.8,9.2,0.2,13,3c3.8,2.7,6.3,6.7,7.1,11.3l35.3,208.8c0.6,3.1-1.6,6-4.7,6.6C1270.8,783.9,1270.6,783.9,1270.2,783.9z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1377,783.9c-0.2,0-0.6,0-0.8,0c-3.1-0.5-5.4-3.3-4.9-6.4l25.3-186.2c0.3-3,0.9-5.6,1.6-8.2 c-14.4-8.3-27.3-23-25.3-38.2c1-7.3,5.8-13.8,12.4-19c-7.4-9.3-7.6-16.7-7.2-20c1.8-13.5,12.2-17.9,20.5-21.3 c8.8-3.6,13.8-6,14.8-14.2l7.8-58c0.5-3.1,3.3-5.3,6.4-4.9c3.1,0.5,5.3,3.3,4.9,6.4l-7.8,58c-2.1,15-13,19.6-21.7,23.2 c-8.3,3.4-12.6,5.5-13.5,12.3c-0.5,3.2,1.7,7.7,5.6,12.4c11.2-5.7,24.2-8.4,33.7-7.2c12.8,1.7,19.6,10.5,17.9,22.9 c-0.9,6.6-4.4,11.5-9.9,13.6c-11.7,4.8-28.8-3.5-39.9-12.1c-1.2-0.9-2.4-1.9-3.4-2.8c-5,3.6-8.7,8-9.2,12.3 c-0.8,6,2.8,13.3,10.1,20c2.4,2.2,5,4.2,7.7,5.9c4.8-10.2,11.7-16.4,17.8-18.9c5.9-2.4,11.8-1.9,16.2,1.4c2.7,2,7,7.2,5.7,17.6 c-1.7,12.6-11.3,19.3-25,17.5c-2.5-0.3-5.1-1-7.8-1.9c-0.3,1.6-0.6,3.2-0.9,4.9l-25.3,186.2C1382.2,781.9,1379.8,783.9,1377,783.9 z M1412.2,577.1c2.1,0.7,4,1.1,5.9,1.4c3.3,0.5,10.9,1.5,12.2-7.7c0.5-3.4,0-6-1.4-7.1c-1-0.8-2.8-0.7-4.9,0.1 C1420.3,565.4,1415.8,569.7,1412.2,577.1z M1404.2,528.1c11.7,9,23.5,12.3,28.3,10.4c0.7-0.3,2.4-1,2.8-4.7 c0.6-4.3,0.1-8.9-8.1-10C1420.8,522.9,1412,524.8,1404.2,528.1z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1319.2,783.9c-3,0-5.5-2.3-5.7-5.2l-8.9-124.2c-0.1-1.7-0.1-3.4-0.1-5c-1.9-0.7-3.9-1.5-5.6-2.3 c-10.8-5.2-17.3-13.2-18-21.8c-0.3-5,1.6-10.2,5.5-15.4c-4.2-3.8-7.2-8.3-7.5-13.2c-0.8-10.8,6.6-15.9,11.9-19.7 c5.5-3.9,8.2-5.9,7.7-11.1l-3.1-42.4l11.4-0.8l3.1,42.4c0.8,11.8-6.9,17.3-12.6,21.3c-5.5,3.8-7.4,5.6-7.2,9.6 c0.1,1.4,1.5,3.5,4.2,5.9c1-0.8,2.2-1.6,3.3-2.4c8.4-5.7,20.4-10.2,29-6.1c2.7,1.4,7.5,4.9,8.2,13.3c0.4,6.1-2.2,10.9-7.2,13.5 c4.6,1.4,8.5,5.7,9,13.5c0.5,6.4-1.9,11.6-6.6,14.8c-4,2.6-9,3.5-14.3,3.3c0,0.6,0,1.3,0.1,1.9l8.9,124.2c0.2,3.2-2.2,5.8-5.2,6 C1319.4,783.9,1319.3,783.9,1319.2,783.9z M1317.2,640.5c2.8,0,5.2-0.5,6.6-1.4c0.6-0.3,1.9-1.3,1.7-4.5c-0.2-2.4-0.9-3.3-1-3.4 c-0.1,0-1,0-2.4,1.1C1320.3,633.7,1318.5,636.5,1317.2,640.5z M1295.8,616.4c-2.4,3-3.8,5.9-3.5,8.2c0.3,4.3,4.8,9.1,11.6,12.4 c0.7,0.3,1.5,0.7,2.2,1c2.1-7.4,5.8-12.7,10.2-15.7C1310.1,621.9,1302.6,619.8,1295.8,616.4z M1305.4,608.2c5,1.9,10.1,3.1,14,2.7 c4.6-0.3,4.4-1.9,4.3-3.4c-0.2-3.1-1.4-3.6-1.8-3.9C1319.2,602.4,1312.7,603.6,1305.4,608.2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M963,574.3h-90.6v90.5H963V574.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M950.7,576.6h-66l33-33L950.7,576.6z M895.8,572h44l-22-22L895.8,572z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1356.6,303.1h-13.7v-3.4h13.7V303.1z M1329.3,303.1h-13.7v-3.4h13.7V303.1z M1302,303.1h-13.7v-3.4h13.7 V303.1z M1274.7,303.1H1261v-3.4h13.7V303.1z M1247.4,303.1h-13.7v-3.4h13.7V303.1z M1220.1,303.1h-13.7v-3.4h13.7V303.1z  M1192.8,303.1h-13.7v-3.4h13.7V303.1z M1165.4,303.1h-13.6v-3.4h13.6V303.1z M1138.1,303.1h-13.7v-3.4h13.7V303.1z M1367.4,296.9 h-3.4v-13.6h3.4V296.9z M1367.4,269.6h-3.4v-13.6h3.4V269.6z M1367.4,242.3h-3.4v-13.6h3.4V242.3z M1367.4,215h-3.4v-13.6h3.4V215 z M1367.4,187.7h-3.4V174h3.4V187.7z M1367.4,160.4h-3.4v-13.6h3.4V160.4z M1367.4,133.1h-3.4v-13.6h3.4V133.1z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1400.1,367.8h-2.5v-1.7h-0.9v-12.9h3.4V367.8z M1383.9,367.8h-13.7v-3.4h13.7V367.8z M1356.6,367.8h-13.7 v-3.4h13.7V367.8z M1329.3,367.8h-13.7v-3.4h13.7V367.8z M1302,367.8h-13.7v-3.4h13.7V367.8z M1274.7,367.8H1261v-3.4h13.7V367.8z  M1247.4,367.8h-13.7v-3.4h13.7V367.8z M1220.1,367.8h-13.7v-3.4h13.7V367.8z M1192.8,367.8h-13.7v-3.4h13.7V367.8z M1165.4,367.8 h-13.6v-3.4h13.6V367.8z M1138.1,367.8h-13.7v-3.4h13.7V367.8z M1400.1,339.6h-3.4V326h3.4V339.6z M1400.1,312.3h-3.4v-13.6h3.4 V312.3z M1400.1,285h-3.4v-13.6h3.4V285z M1400.1,257.7h-3.4v-9.1l4.2-4.2l2.4,2.4l-3.2,3.2V257.7z M1412.9,237.1l-2.4-2.4 l9.7-9.7l2.4,2.4L1412.9,237.1z M1432.3,217.9l-2.4-2.4l9.7-9.7l2.4,2.4L1432.3,217.9z M1451.5,198.6l-2.4-2.4l7.6-7.6h4.2v3.4 h-2.8L1451.5,198.6z M1588.4,191.9h-4.4v-3.4h4.4V191.9z M1570.3,191.9h-13.7v-3.4h13.7V191.9z M1543,191.9h-13.7v-3.4h13.7V191.9 z M1515.7,191.9H1502v-3.4h13.7V191.9z M1488.4,191.9h-13.7v-3.4h13.7V191.9z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1337.7,272.6h-3.8v-3.4h0.3v-9.9h3.4V272.6z M1320.3,272.6h-13.7v-3.4h13.7V272.6z M1337.7,245.8h-3.4v-13.6 h3.4V245.8z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1124.5,319.3c5.5,0,10-8,10-17.9s-4.5-17.9-10-17.9s-10,8-10,17.9S1119,319.3,1124.5,319.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1124.5,384c5.5,0,10-8,10-17.9c0-9.9-4.5-17.9-10-17.9s-10,8-10,17.9C1114.5,376,1119,384,1124.5,384z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M273.8,619.5h-3.4v-5.3h3.4V619.5z M273.8,600.4h-3.4v-13.6h3.4V600.4z M273.8,573.1h-3.4v-13.6h3.4V573.1z  M273.8,545.8h-3.4v-13.6h3.4V545.8z M273.8,518.5h-3.4v-13.6h3.4V518.5z M273.8,491.2h-3.4v-13.6h3.4V491.2z M273.8,464h-3.4 v-13.6h3.4V464z M273.8,436.7h-3.4V423h3.4V436.7z M273.8,409.4h-3.4v-13.6h3.4V409.4z M273.8,382.1h-3.4v-13.6h3.4V382.1z  M273.8,354.8h-3.4v-13.6h3.4V354.8z M273.8,327.5h-3.4v-13.6h3.4V327.5z M368.8,303.1h-13.7v-3.4h13.7V303.1z M341.5,303.1h-13.7 v-3.4h13.7V303.1z M314.1,303.1h-13.7v-3.4h13.7V303.1z M286.8,303.1h-13.7v-3.4h13.7V303.1z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M246.4,433.4H243v-13.6h3.4V433.4z M246.4,406.1H243v-13.6h3.4V406.1z M246.4,378.8H243v-13.6h3.4V378.8z  M246.4,351.5H243v-13.6h3.4V351.5z M246.4,324.2H243v-13.6h3.4V324.2z M246.4,296.9H243v-13.6h3.4V296.9z M246.4,269.6H243v-13.6 h3.4V269.6z M246.4,242.3H243v-13.6h3.4V242.3z M246.4,215H243v-13.6h3.4V215z M246.4,187.7H243V174h3.4V187.7z M246.4,160.4H243 v-13.6h3.4V160.4z M246.4,133.1H243v-13.6h3.4V133.1z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272,625c5.4,0,9.8-2.4,9.8-5.5c0-3-4.4-5.5-9.8-5.5c-5.4,0-9.8,2.4-9.8,5.5C262.3,622.6,266.6,625,272,625z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodin);
export default __webpack_public_path__ + "static/media/rodin.df94a4c02a8d28c0b062e049501a5a5d.svg";
export { ForwardRef as ReactComponent };